{
    "alerts": {
        "AN_ERROR_OCCURRED": "An error occured. Please try again.",
        "ANCHOR_TAB_STRING_NOT_FOUND": "Each signer must be required to sign at least one document.",
        "DUPLICATE_SIGNER_ERROR": "Duplicate signers must have same signing option. ",
        "DUPLICATE_EMAIL_MOBILE_SIGNER_ERROR": "The email addresses and telephone numbers of the participants must be individual and cannot coincide with each other",
        "EMAIL_AND_PHONE_MANDATORY": "Email and Mobile number are mandatory for all signers",
        "EXCLUDE_ALFA_CASE_STATUS_ERROR_MESSAGE": "Envelope can not be created for this quote as it is not submitted for credit",
        "GENERIC_ERROR": "Envelope creation failed due to unknown error.",
        "GUARANTOR_WARNING_MESSAGE": "Bundles including guarantors are not authorised for Esign",
        "INVALID_EMAIL_ADDRESS_FOR_RECIPIENT": "Invalid email address provided for signer(s).",
        "MANDATORY_FIELD_FOR_SIGNER_ERROR": "Email and Mobile number are mandatory for all signers.",
        "NO_ACCESS_TO_PROPOSAL_TRACKING_OR_ESIGN": "You do not have access to Proposal Tracking or eSignature modules.",
        "NO_DOCUMENT_SELECTED": "Please select at least one document.",
        "NO_ENVELOPE_FOUND": "No envelope found for the proposal.",
        "NO_MODULE_ASSIGNED": "No modules assigned",
        "NO_PROPOSALS_AVAILABLE_FOR_GIVEN_SEARCH_CRITERIA": "No proposals available for given search criteria",
        "NO_PROPOSALS_AVAILABLE_FOR_GIVEN_SEARCH_CRITERIA_CLICK_CLEAR": "No proposals available for given search criteria. Click on CLEAR button to view all records.",
        "NO_RESULTS_FOUND": "No Results Found",
        "NO_SIGNED_DOCUMENTS_AVAILABLE": "No documents available for this envelope.",
        "NO_SIGNER_DOCUMENT_SELECTED_ACTION": "Please select at least one document and one signer to create an envelope.",
        "NO_SIGNER_OR_DOCUMENT_SELECTED": "No Signer/Document Selected",
        "NO_SIGNER_SELECTED": "Please select at least one signer.",
        "SEARCH_FOR_A_PROPOSAL_TO_CONTINUE": "Search for a proposal to continue.",
        "START_DATE_WARNING_MESSAGE": "The start date of this contract happens before its signature, which voids it. Please verify the dates and ensure that of the signature comes prior to or the same date as the contract start date"
    },
    "docusignErrorMessages": {
        "ANCHOR_TAB_STRING_NOT_FOUND": "The specified Anchor Tab string was not found in the document.",
        "INVALID_EMAIL_ADDRESS": "Invalid Email Address",
        "INVALID_EMAIL_ADDRESS_FOR_RECIPIENT": "The email address for the recipient is invalid.",
        "PHONE_NUMBER_INVALID": "Phone number is not valid."
    },
    "labels": {
        "ACTION": "Action",
        "ADD": "Add",
        "ADD_NEW_SIGNER": "Add New Signer",
        "ADD_NEXT": "Add Next",
        "ADD_SIGNER": "Add Signer",
        "ADMIN_UTILITY": "Admin Utility",
        "APPROVED": "Approved",
        "APPROVED_WITH_CONDITIONS": "Approved with conditions",
        "ASSOCIATE": "Associate",
        "ASSOCIATED_PARTIES": "Associated Parties",
        "AUTO_APPROVED": "Auto-Approved",
        "AWAITING_FURTHER_INFORMATION_DOCUMENTS": "Awaiting further Information/Documents",
        "BACK_TO_DASHBOARD": "Back to Dashboard",
        "BULK_EREGISTRY_UTILITY": "Bulk E-Registry Utility",
        "BUNDLE": "Bundle",
        "CLEAR": "Clear",
        "CO-BORROWER": "Co-Borrower",
        "COMBINED": "Combined",
        "COMPLETED": "Completed",
        "CONTRACT_PAID_OFF": "Contract paid off",
        "COUNTRY": "Country",
        "CREATE_ENVELOPE": "Create Envelope",
        "CREATED": "Created",
        "CREATED_DATE": "Created Date",
        "CREDIT_DECISION_ROUTED_FOR_MANUAL_REVIEW": "Credit Decision Routed For Manual Review",
        "DEALER": "Dealer",
        "DEALER_REFERENCE": "Dealer Reference",
        "DEALERSHIP_NAME": "Dealership Name",
        "DECLINED": "Declined",
        "DECLINED_DATE": "Declined Date",
        "DECLINED_REASON": "Declined Reason",
        "DELETED": "Deleted",
        "DELIVERED": "Delivered",
        "DOCUMENT_NAME": "Document Name",
        "DOCUMENTS": "Documents",
        "DOCUMENTS_SELECTED": "documents selected",
        "DOWNLOAD": "Download",
        "E_SIGNATURE": "E-Signature",
        "E_SIGNATURE_DASHBOARD": "E-Signature Dashboard",
        "EMAIL": "Email",
        "ENVELOPE_ID": "Envelope ID",
        "ENVELOPE_REVIEW": "Envelope Review",
        "E-REGISTRY_DOWNLOAD": "E-Registry",
        "EXAMPLE_PHONE_NUMBER": "Ex. +44 123456789",
        "EXPIRED": "Expired",
        "FETCHING_DOCUMENTS_FOR": "Fetching documents for",
        "GERMANY": "Germany",
        "GET_STATUS": "Get Status",
        "GUARANTOR": "Guarantor",
        "HI": "Hi",
        "ICS_REFERENCE": "ICS ID",
        "ISD_CODE_IS_REQUIRED": "ISD Code is required",
        "JDF_SIGNER": "JDF Signer",
        "MATURITY_DATE": "Maturity Date",
        "MERGER_AND_ACQUISITION": "Merger & Acquisition",
        "MOBILE": "Mobile",
        "NAME": "Name",
        "NO_DECLINING_REASON_PROVIDED": "No Declining Reason Provided",
        "NOT_AVAILABLE": "Not Available",
        "NOT_SIGNED": "Not Signed",
        "NOT_VIEWED": "Not Viewed",
        "OF": "of",
        "ON_DEMAND": "On Demand",
        "OPTION": "Option",
        "OPTIONS": "Options",
        "ORDER": "Order",
        "PRIMARY": "Primary",
        "PRIMARY_CUSTOMER": "Primary Customer",
        "PROCESSING": "Processing",
        "PRODUCT": "Product",
        "PROPOSAL": "Proposal",
        "PROPOSAL_DETAILS": "Proposal Details",
        "PROPOSAL_TRACKING": "Proposal Tracking",
        "PROPOSED": "Proposed",
        "QUOTE": "Quote",
        "QUOTE_STATUS": "Quote Status",
        "REVIEW_MESSAGE_DETAILS_CANNOT_UPDATE": "c. These details cannot be updated once Envelope is sent.",
        "REVIEW_MESSAGE_ISD_CODE": "b. Mobile number must be pre-fixed with country code (ISD Code) for all signers. Example: +34 123456789",
        "REVIEW_MESSAGE_OTP": "a. Each signer will be authenticated via One Time Password (OTP) sent on Mobile number provided below.",
        "ROLE": "Role",
        "SALESPERSON": "Salesperson",
        "SAVE_&_ADD_NEXT_SIGNER": "Save & Add Next Signer",
        "SAVE_SIGNER": "Save Signer",
        "SEARCH": "Search",
        "SELECT_DOCUMENTS": "Select Documents",
        "SELECTED_DOCUMENTS": "Sent Documents",
        "SELECT_THIRD_PARTY": "Select Third Party",
        "SEND_ENVELOPE": "Send Envelope",
        "SENDING_ENVELOPE": "Sending Envelope",
        "SENT": "Sent",
        "SENT_/_VIEWED": "Sent / Viewed",
        "SENT_DATE": "Sent Date",
        "SEPARATE": "Separate",
        "SIGN_BY_EMAIL": "Sign by Email",
        "SIGN_NOW": "Sign Now",
        "SIGNED": "Signed",
        "SIGNED_DATE": "Signed Date",
        "SIGNER": "Signer",
        "SIGNERS": "Signers",
        "SIGNING_OPTION": "Signing Option",
        "SIGNING_ORDER": "Signing Order",
        "SIGNING_ORDER_PREVIEW": "Signing Order Preview",
        "SIGNING_STATUS": "Signing Status",
        "PORTUGAL": "Portugal",
        "SPAIN": "Spain",
        "START_DATE": "Start Date",
        "STATUS": "Status",
        "STATUS_DATE": "Status Date",
        "SUBMITTED": "Submitted",
        "TEMPLATE": "Template",
        "THIRD_PARTY": "Third Party",
        "UNDELIVERABLE": "Undeliverable",
        "UNITED_KINGDOM": "United Kingdom",
        "UPDATING_STATUS": "Updating Status",
        "VIEWED": "Viewed",
        "VIEWED_DATE": "Viewed Date",
        "VOIDED": "Voided",
        "WITHDRAWN": "Withdrawn",
        "PRIMARY_QUOTE": "Primary Quote",
        "ENVELOPE_SENT_UNDER_PROCESS": "Envelope is being sent. Please wait till the process completes",
        "ENVELOPE_SUCCESSFULLY_SENT": "Your envelope has been successfully sent",
        "ADD_PROXY": "Add Proxy",
        "PROXY": "Proxy",
        "you can only assign": "you can only assign",
        "representatives to the": "representatives to the",
        "ADD_NEW_PROXY": "Add New Proxy"
    },
    "messages": {
        "BUNDLE_NUMBER_NOT_FOUND": "No results found since no quotes found for the given bundle number.",
        "CREATE_ON_DEMAND_SIGNER_FOR_ASSOCIATE": "Please create this signer as an on-demand signer",
        "DOCUMENT_DOWNLOAD_FAILED": "Document Download from S3 failed",
        "ICS_NUMBER_NOT_FOUND": "No results found since no quotes found for the given ICS reference number.",
        "INVALID_BUNDLE_NUMBER": "Bundle Number provided is invalid. Please provide a valid bundle number and retry.",
        "INVALID_ICS_NUMBER": "ICS reference provided is invalid. Please provide a valid ICS reference number and retry.",
        "INVALID_PRIMARY_CUSTOMER": "Primary Customer's name provided is invalid. Please provide a valid name and retry.",
        "INVALID_QUOTE_NUMBER": "Quote Number provided is invalid. Please provide a valid quote number and retry.",
        "PRIMARY_CUSTOMER_NOT_FOUND": "No results found since given primary customer does not exist in the system.",
        "QUOTE_NUMBER_NOT_FOUND": "No results found since given Bundle Number and given Quote Number do not correspond to a common bundle."
    },
    "products": {
        "DPFR_24_MONTH_LOAN_STOCK_DE": "DPFR - 24 month Loan Stock DE",
        "DPFR_LOAN_DE": "DPFR - Loan DE",
        "DPFR_LOAN_STOCK_DE": "DPFR - Loan Stock DE",
        "DPFR_NON_FULL_PAYOUT_LEASE_DE": "DPFR - Non Full Payout Lease DE",
        "DPFR_OPERATING_LEASE_DE": "Operating Lease DE",
        "LOAN_DE": "Loan DE",
        "NON_FULL_PAYOUT_LEASE_DE": "Non Full Payout Lease DE",
        "OPERATING_LEASE_DE": "Operating Lease DE"
    }
}
